require('./bootstrap');

require('./components/Welcome');
